import { DomainsPermissions } from '../../constants';
import { dynamicLoadApiQueries } from './dynamicLoadApiQueries';
export const domainsPermissions = async _ref => {
  let httpClient = _ref.httpClient,
    msid = _ref.request.msid;
  const _await$dynamicLoadApi = await dynamicLoadApiQueries(httpClient),
    domainsAccountPermissions = _await$dynamicLoadApi.domainsAccountPermissions;
  const _await$domainsAccount = await domainsAccountPermissions({}),
    domainPermissions = _await$domainsAccount.domainPermissions;
  const hasBillingPermissions = !!(domainPermissions != null && domainPermissions.includes(DomainsPermissions.AccountLevelPurchaseDomain)) || !!msid && !!(domainPermissions != null && domainPermissions.includes(DomainsPermissions.SiteLevelPurchaseDomain));
  const hasManageDomainPermissions = hasBillingPermissions || !!(domainPermissions != null && domainPermissions.includes(DomainsPermissions.AccountLevelManageDomains)) || !!msid && !!(domainPermissions != null && domainPermissions.includes(DomainsPermissions.SiteLevelManageDomains));
  return {
    hasManageDomainPermissions,
    hasBillingPermissions
  };
};
//# sourceMappingURL=domainsPermissions.js.map